import * as React from "react";
import { useState, useMemo } from "react";
import usePermissions from "hooks/usePermissions";
import BootstrapModalConfirm from "components/bootstrap/BootstrapModalConfirm";
import { useRemoveEvidence } from "security-app/hooks/useInvestigationsAPI";
import LogsList from "./LogsList";
function Logs({ investigation }) {
  const { isPermitted } = usePermissions();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteLog, setDeleteLog] = useState(null);
  const canManageEvidence = useMemo(
    () => !investigation.archived && isPermitted("investigations:edit"),
    [investigation.archived, isPermitted]
  );
  const { removeEvidence, removingEvidence } = useRemoveEvidence();
  const removeLog = async () => {
    await removeEvidence({
      invId: investigation.id,
      payload: {
        logs: [{ id: deleteLog.id, index: deleteLog.index }]
      }
    });
    setShowDeleteDialog(false);
    setDeleteLog(null);
  };
  const onDelete = (log) => (e) => {
    e.stopPropagation();
    setShowDeleteDialog(true);
    setDeleteLog(log);
  };
  const onCancelDelete = () => {
    setShowDeleteDialog(false);
    setDeleteLog(null);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(LogsList, { investigation, canManageEvidence, onDelete })), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showDeleteDialog,
      title: "Delete Log",
      onConfirm: removeLog,
      onCancel: onCancelDelete,
      confirmButtonDisabled: removingEvidence
    },
    "Are you sure you want to delete this Log?"
  ));
}
export default Logs;
